// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:44:43

export default {
  "id": "radiant-rush",
  "slug": "radiant-rush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b13ead7dca674c6fafde37a0b3bba97c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b13ead7dca674c6fafde37a0b3bba97c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Radiant Rush",
      "description": "Radiant Rush is a minimalist synthwave drifting game where you control only the car's steering—not its speed. Your goal is to complete increasingly challenging levels while collecting all the datacubes scattered throughout.",
      "instructions": "Use the mouse, the arrow keys, A and D or your finger to steer",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "1player",
        "car",
        "drift",
        "music"
      ]
    },
    "zh-CN": {
      "title": "光辉狂奔",
      "description": "《光辉冲刺》是一款简约合成波漂移游戏，你只能控制汽车的转向——而不是速度。你的目标是完成越来越具有挑战性的关卡，同时收集散布在关卡中的所有数据立方体。",
      "instructions": "使用鼠标、箭头键、A键和D键或你的手指来操控方向",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "1玩家",
        "汽车",
        "漂移",
        "音乐"
      ]
    },
    "zh-TW": {
      "title": "輝煌狂奔",
      "description": "輝煌疾馳是一款簡約合成波駛行遊戲，您只能操控車輛的方向盤——而非速度。您的目標是在收集散落在各級別中的所有數據立方體的同時，完成越來越挑戰性的關卡。",
      "instructions": "使用滑鼠、方向鍵、A和D鍵或你的手指來操縱方向",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "1玩家",
        "車輛",
        "漂移",
        "音樂"
      ]
    },
    "zh-HK": {
      "title": "閃耀狂潮",
      "description": "Radiant Rush 是一款簡約合成波漂移遊戲，你只需控制汽車的方向盤——不控制其速度。你的目標是在收集分佈於全場的所有數據塊的同時，完成越來越挑戰性的關卡。",
      "instructions": "使用滑鼠、方向鍵、A 和 D 鍵或手指來操控方向",
      "genres": [
        "賽車及駕駛"
      ],
      "tags": [
        "1玩家",
        "車輛",
        "漂移",
        "音樂"
      ]
    },
    "ja": {
      "title": "レイジアント・ラッシュ",
      "description": "レディアント・ラッシュは、車のスピードを操作せずにステアリングだけをコントロールするミニマリスト・シンセイズウェイドリフトゲームです。あなたの目標は、データキューブをすべて収集しながら、次第に難しくなるレベルをクリアすることです。",
      "instructions": "マウス、矢印キー、AとDキーや指を使って操作してください",
      "genres": [
        "レーシング＆ドライビング"
      ],
      "tags": [
        "1プレイヤー",
        "車",
        "ドリフト",
        "音楽"
      ]
    },
    "ko": {
      "title": "라디언트 러시",
      "description": "라디언트 러시는 최소한의 시설을 가진 시뮬웨이브 드리프팅 게임으로, 차량의 속도 대신 스티어링만을 제어합니다. 목표는 모든 데이터쿼브를 모두 수집하면서 점점 더 어려운 레벨을 완료하는 것입니다.",
      "instructions": "마우스, 방향키, A와 D 키 또는 손가락으로 방향을 조정하세요",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "1플레이어",
        "자동차",
        "드리프트",
        "음악"
      ]
    },
    "fr": {
      "title": "Eclaté déferlement",
      "description": "Radiant Rush est un jeu de drift synthwave minimaliste où vous contrôlez uniquement la direction du véhicule—pas sa vitesse. Votre objectif est de terminer des niveaux de plus en plus difficiles tout en collectant tous les datacubes disséminés à travers le niveau.",
      "instructions": "Utilisez la souris, les touches fléchées, A et D ou votre doigt pour diriger.",
      "genres": [
        "Course et conduite"
      ],
      "tags": [
        "1 joueur",
        "voiture",
        "drift",
        "musique"
      ]
    }
  }
};
